/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
import React from 'react';

import Lane from '../../../shared/Lane';
import CardWarning from '../../../Turma/pages/Home/components/CardWarning';
import * as Styles from './styles';

function Screen({ warnings, title, getMoreWarnings, onClick, fullButton }) {

  return (
    <Styles.Container>
      <Lane title={title} paginationHook={getMoreWarnings} fullButton={fullButton}>
        {(!warnings || !warnings.length) && (
          <Styles.EmptyListText>
            Sem avisos
          </Styles.EmptyListText>
        )}
        {warnings && warnings.map(warning => {
          return (
            <Styles.Wrapper key={`${warning.id}`}>
              <CardWarning 
                warning={warning} 
                onClick={(warning) => onClick(warning)}
              />
            </Styles.Wrapper>
          );
        })}
      </Lane>
    </Styles.Container>
  );
}

export default Screen;

